<template>
  <div
    @click="toggle"
    @mouseover="$event=>emit('_mouseover', $event, category)"
    @mouseleave="emit('_mouseleave', '')"
    class="group inline-flex items-center rounded-md px-2 py-1 text-xs font-medium uppercase "
    :class="{
      '!bg-gray-200': !enabled,
      'text-gray-400': !enabled,
      'cursor-pointer ': interactive,
      'hover:brightness-110': interactive
    }"
    :style="{
      'background-color': forceBackgroundColor!=''?forceBackgroundColor:categoryColorScale(category),
      'color': forceBackgroundColor!=''?'black':categoryTextColorScale(category)
    }"
  >
  <span >{{ category }} </span>
    <svg viewBox="0 0 14 14" class="h-3.5 w-3.5 stroke-black/50 group-hover:stroke-black" v-if="showRemove">
        <path d="M4 4l6 6m0-6l-6 6" />
      </svg>
  </div>
</template>

<script setup>
import { categoryColorScale,categoryTextColorScale } from "@/assets/baseTypes.js";
const props = defineProps({
  category: {
    type: String,
    required: true,
  },
  enabled: {
    type: Boolean,
    required: true,
  },
  showRemove: {
    type: Boolean,
    default: true,
  },
  forceBackgroundColor: {
    type: String,
    default: '',
  },
  interactive: {
    type: Boolean,
    default: true,
  },
});

const emit  = defineEmits(["update:enabled", "_mouseover","_mouseleave"]);

const toggle = () => {
  if(!props.interactive) return;
  emit("update:enabled", !props.enabled);
};

</script>

<style lang="scss" scoped></style>
